import { createSlice } from "@reduxjs/toolkit";

const webappSlice = createSlice({
  name: "webapp",
  initialState: {
    isLoading: false,
    creditRemainder: {},
    requestLoanList: [],
    loanDetails: {},
    profile: {}

  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setCreditRemainder(state, action) {
      state.creditRemainder = action.payload;
    },
    setRequestLoanList(state, action) {
      state.requestLoanList = action.payload;
    },
    setLoanDetails(state, action) {
      state.loanDetails = action.payload;
    },
    setProfile(state, action) {
      state.profile = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setCreditRemainder,
  setRequestLoanList,
  setLoanDetails,
  setProfile,

} = webappSlice.actions;
export default webappSlice.reducer;
